// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"05276c2a","845":"6b08ed0e"}[chunkId] + ".chunk.js";
};